import { SET_SELECTED_PROJECT } from "@/store/mutations.js";
export const projects = {
  getFormData: (state) => {
    const payload = {
      id: state.selectedProject.id,
    };
    
    if (state.selectedProject.name) {
      payload.name = state.selectedProject.name;
    }

    if (state.selectedProject.properties) {
      const props = {};
      Object.keys(state.selectedProject.properties).forEach(key => {
        const value = state.selectedProject.properties[key];
        if (value !== null && value !== undefined && value !== "") {
          if (key === "start_date" || key === "end_date") {
            props[key] = value + "T00:00:00Z";
          } else {
            props[key] = value;
          }
        }
      });
      if (Object.keys(props).length > 0) {
        payload.properties = props;
      }
    }

    return payload;
  },
  saveCallBack: (response, state, dispatch) => {
    state.selectedProject.id = response.data.id;
    dispatch("fetchList");
  },
  validate: (state) => {
    return (
      state.selectedProject.name?.length > 2 && state.selectedProject.company_id
    );
  },
  reset: (commit) => {
    commit(SET_SELECTED_PROJECT, {
      id: null,
      name: "",
      company_id: "",
    });
  },
  getFetchParams: (state) => {
    let params = {};

    if (state.filters.company) {
      params.company = state.filters.company;
    }

    return params;
  },
};
